export enum ConsolidatedBillingOrderStatusType {
  Open = "Open",
  Delivered = "Delivered",
  PendingInvoice = "PendingInvoice",
  PendingRefund = "PendingRefund",
  Invoiced = "Invoiced",
  Sent = "Sent",
  Paid = "Paid",
  PaidManually = "PaidManually"
}
